<template>

  <div class="cvs-list-container">

    <SmartTitle class="main-title" weight="medium">Listagem de CVs</SmartTitle>

    <SmartSearch class="main-search" v-if="false">
      <v-text-field
        v-model="search"
        @keyup="searchCVList"
        append-icon="search"
        placeholder="Pesquisar..."
        single-line
        hide-details
        class="search"
      />
    </SmartSearch>

    <div class="container-choice-of-pdvs d-flex justify-space-between main-section">

      <div class="block-item-choice-of-pdvs flex-column">

        <SmartTitle class="title-choice-of-pdvs" weight="medium" >Escolher loja</SmartTitle>

        <SmartTitle class="subtitle-choice-of-pdvs" weight="medium" >Selecione a loja para a localização de CVs</SmartTitle>

      </div>

      <div class="block-item-choice-of-pdvs d-flex justify-end">

        <SmartSelect
          :items="userStoresGetter"
          item-text="name"
          item-value="id"
          no-data-text="Sem loja"
          @change="getPlaceSupervisors(selectedStore)"
          v-model="selectedStore"
          placeholder="Selecione o PDV"
          style="width: 18rem; margin-top: -1.4rem;"
        />

      </div>

    </div>


    <div v-if="alertSelectPDV" class="container-alert-select-pdvs mt-5 main-section">

      <div class="item-container-alert-select-pdvs">

        <div class="center-block-info">
          <SmartIcon
            name="warning"
            style="width: 30px; height: 30px; color: orange;"
          />
          <br/><br/>
          <span>Nada Selecionado</span>
          <br/><br/>
          <span>Selecione uma loja</span>
        </div>

      </div>

    </div>

    <div v-if="alertNotExistSupervisors" class="container-alert-select-pdvs mt-5">

      <div class="item-container-alert-select-pdvs">

        <div class="center-block-info">
          <br/><br/>
          <span>Não Existe Supervisores e CVs nessa loja</span>
        </div>

      </div>

    </div>


    <div v-if="haveSupervisors" class="mt-5">

      <section
        v-for="supervisor in getSupervisors" :key="supervisor.id">

        <v-expansion-panel>

          <v-expansion-panel-content>

            <template v-slot:header>

              <div
                class="smartListItem w-full flex flex-row justify-center align-center mt-1 p-1 cv-list-container">

                <div class="item mt-2 flex flex-col align-center text-center">

                  <h3>Coordenador</h3>

                  <SmartP>
                    {{ supervisor.coordinators }}
                  </SmartP>
                </div>

                <div class="item mt-2 flex flex-col align-center text-center">
                  <h3>Gerente</h3>
                  <SmartP>
                    {{ supervisor.managers }}
                  </SmartP>
                </div>

                <div class="item mt-2 flex flex-col align-center text-center">

                  <h3>Supervisor</h3>
                  <SmartP>
                    {{ supervisor.name  }}
                  </SmartP>

                </div>

                <div class="item mt-2 flex flex-col align-center text-center">

                  <h3>Soma de ausência</h3>

                  <SmartP>{{ supervisor.ausencia_equipe }}</SmartP>

                </div>

              </div>

            </template>

            <v-card>

              <v-card-text>

                <VDataTable
                  :headers="headers"
                  :items="supervisor.sale_consultants"
                  hide-actions
                  class=""
                >

                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.registration }}</td>
                    <td>{{ props.item.data_inicio | data}}</td>
                    <td>{{ props.item.situacao_pf ? props.item.situacao_pf : 'N/A' }}</td>
                  </template>

                </VDataTable>

              </v-card-text>

            </v-card>

          </v-expansion-panel-content>

        </v-expansion-panel>

      </section>

    </div>

  </div>

</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CvsList',

  components: {
    SmartSearch: () => import('../../../../packages/SmartSearch/index.vue')
  },

  data() {
    return {
      selectedStore: null,
      search: '',
      haveSupervisors: false,
      alertSelectPDV: true,
      alertNotExistSupervisors: false,
      headers: [
        { text: 'CV', value: 'cv', sortable: false },
        { text: 'Matrícula', value: 'matricula', sortable: false },
        { text: 'Fora', value: 'fora', sortable: false },
        { text: 'Motivo', value: 'motivo', sortable: false }
      ]
    };
  },


  computed: {
    ...mapGetters({
      views: 'view/views',
      userStoresGetter: 'cvs/userStoresGetter',
      userStoresCreateGetter: 'cvs/userStoresCreateGetter',
      storeSupervisorsGetter: 'cvs/storeSupervisorsGetter',
      selectedStoreGetter: 'cvs/selectedStoreGetter',
      selectedViewGetter: 'cvs/selectedViewGetter',
      keyComponentGetter: 'cvs/keyComponentGetter',
      afterCreateGetter: 'cvs/afterCreateGetter'
    }),

    isRegionalAndselectedStore() {
      return !!(this.selectedViewGetter && this.selectedStoreGetter);
    },

    getSupervisors() {
      return this.storeSupervisorsGetter.supervisors || [];
    }
  },


  methods: {
    ...mapActions({
      fetchUserStores: 'cvs/fetchUserStores',
      fetchPlaceSupervisors: 'cvs/fetchPlaceSupervisors',
      fetchViewsGoals: 'view/fetchViewsGoals',
      fetchGoalsPlaces: 'cvs/fetchGoalsPlacesByUserViews',
      fetchSaleConsultants: 'cvs/fetchSaleConsultants',
      updateKeyComponent: 'cvs/updateKeyComponent',
      setSelectedView: 'cvs/setSelectedView',
      setSelectedStore: 'cvs/setSelectedStore',
      setAfterCreate: 'cvs/setAfterCreate'
    }),

    disableKeysWithLessThanThreeCharacters(keyCode) {
      return [8, 32, 37, 38, 39, 40].includes(keyCode);
    },

    async searchCVList(e) {
      if (!this.search) {
        if (!this.disableKeysWithLessThanThreeCharacters(e.keyCode)) {
          this.loading = true;
          await this.fetchCriticPoint();
        }
      } else if (this.search.length < 4 || this.disableKeysWithLessThanThreeCharacters(e.keyCode)) {
        return;
      } else {
        this.loading = true;
        await this.fetchCriticPoint(this.search);
      }
      this.loading = false;
    },

    close() {
      this.modal = null;
      this.showDrawer = null;
    },

    routerPush(supervisorId) {
      const placeId = this.selectedStoreGetter;
      this.$router.push({ name: 'DetalhesCV', params: { placeId, supervisorId } });
    },

    async getPlaceSupervisors(itemSelectStore) {
      this.setSelectedStore(itemSelectStore);
      this.isLoading = true;
      await this.fetchPlaceSupervisors(itemSelectStore);
      this.isLoading = false;
    },

    async fetchPlacesByViewId(id) {
      this.setSelectedView(id);
      this.setSelectedStore('');
      await this.fetchPlaceSupervisors();
      this.isLoading = true;
      await this.fetchGoalsPlaces(id);
      this.isLoading = false;
    }
  },


  watch: {
    getSupervisors(value) {
      if (value.length > 0) {
        this.alertSelectPDV = false;
        this.haveSupervisors = true;
        this.alertNotExistSupervisors = false;
      } else {
        this.alertSelectPDV = false;
        this.haveSupervisors = false;
        this.alertNotExistSupervisors = true;
      }
    }
  },

  async mounted() {
    this.fetchViewsGoals();
    this.updateKeyComponent(this.keyComponentGetter + 1);
    this.fetchGoalsPlaces();
  }
};


</script>

<style lang="scss" scoped>


    .cvs-list-container {
        width: 100%;
        padding: 0;
    }


    .cvs-list-title {
        font-size: 2.2em;
    }


    .input-search {
        width: 17rem;
        margin-top: 1.4rem;
    }


    .container-choice-of-pdvs {
        width: 100%;
        margin-top: 1.4rem;
        padding: 0 1.5rem 0 1.5rem;
        border: 1px solid rgba(0,0,0,0.1);
        border-radius: 4px;
    }


    .block-item-choice-of-pdvs {
      padding-top: 1.5rem;
    }


    .block-item-choice-of-pdvs:nth-child(2n) {
      width: 5rem;
    }


    .title-choice-of-pdvs {
        font-size: 1em;
    }


    .subtitle-choice-of-pdvs {
        font-size: 0.8em;
        color: rgba(0,0,0,0.3);
    }

    .container-alert-select-pdvs {
      position: relative;
      width: 100%;
      height: 10rem;
      background-color: white;
      border: 1px solid rgba(0,0,0,0.1);
      border-radius: 6px;
    }

    .item-container-alert-select-pdvs {
      width: 18rem;
      height: 8rem;
      padding: 1.2rem 1rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .center-block-info {
      width: 100%;
      height: 60px;
      text-align: center;
    }

    span:nth-child(1n) {
      font-weight: 600;
      color: rgba(0,0,0,0.6);
    }

    span:nth-child(2n) {
      color: rgba(0,0,0,0.4);
    }

    div.cv-list-container {
      border: 1px solid rgba(0,0,0,0.1);
      border-radius: 4px;
    }


</style>
